import { render, staticRenderFns } from "./BaseButton.vue?vue&type=template&id=6ff48049&scoped=true&"
import script from "./BaseButton.vue?vue&type=script&lang=js&"
export * from "./BaseButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseButton.vue?vue&type=style&index=0&lang=less&"
import style1 from "./BaseButton.vue?vue&type=style&index=1&id=6ff48049&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff48049",
  null
  
)

export default component.exports